// extracted by mini-css-extract-plugin
export default {"container":"quill-html-renderer_container__vcULU"};